import { render, staticRenderFns } from "./Breves.vue?vue&type=template&id=2b737326"
import script from "./Breves.vue?vue&type=script&lang=js"
export * from "./Breves.vue?vue&type=script&lang=js"
import style0 from "./Breves.vue?vue&type=style&index=0&id=2b737326&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports